const hideDateElement = () => {
	document.querySelector('.article-wrapper > .information > .date')
		.classList.add('-hide');
};

const setDateString = (string) => {
	document.querySelector('.article-wrapper > .information > .date').innerText = string;
};

const setArticleDate = (type, data) => {
	/**
	 * it's a period (from `data_start` to `date_end`)
	 */
	if (type === 'promotions') {
		if (!data.date_start || !data.date_end) {
			hideDateElement();
			return;
		}

		setDateString(`${data.date_start} ~ ${data.date_end}`);
		return;
	}

	/**
	 * only one `date`
	 */
	if (!data.date) {
		hideDateElement();
		return;
	}

	setDateString(data.date);
};

export default setArticleDate;



// WEBPACK FOOTER //
// ./src/js/about/setArticleDate.js